module.exports = __webpack_public_path__ + "img/icon_service_info_total_3.6c5981fb.png";